module.exports = __webpack_public_path__ + "img/maker-5.66b1ebab.jpg";